import { isFormattedText } from '../../../../../utils';
import { getMaxLinesForVariant } from './get-max-lines';

export const validateForm = (formData: any): Record<string, string> => {
  const errors: Record<string, string> = {};

  // Validar claim - máx líneas dinámico
  if (formData.claim && isFormattedText(formData.claim)) {
    const { stage, adChannel, variant } = formData;

    if (stage && adChannel && variant) {
      const maxLines = getMaxLinesForVariant(stage, adChannel, variant);
      const actualLines = formData.claim.numberOfLines || 0;

      if (actualLines > maxLines) {
        errors.claim = `El claim debe tener máximo ${maxLines} líneas (actualmente tiene ${actualLines})`;
      }
    }
  }

  // Validar subheadline - máx 2 líneas
  if (formData.subheadline) {
    const lines = formData.subheadline.split('\n').filter((l: string) => l.trim().length > 0);
    if (lines.length > 2) {
      errors.subheadline = `La bajada debe tener máximo 2 líneas (actualmente tiene ${lines.length})`;
    }
  }

  return errors;
};
